export default __webpack_public_path__ + "static/media/status_icon.49d3accf.svg";